import { API } from '../../../config';
import { errorHandler } from '../auth/errorAction';

export const unmountListAgencies = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_AGENCIES'})
}

export const unmountDetailAgencies = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_AGENCIES'})
}

export const unmountMasterAgencies = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_MASTER_AGENCIES'})
}

export const listAgencies = (meta) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_AGENCIES' })
  return API.GET('/agency/list', meta).then((response) => {
    dispatch({
      type: 'LOAD_DATA_AGENCIES_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: response.meta.page,
          total: response.meta.total,
          perpage: response.meta.perpage
        }
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_AGENCIES_FAILED' }), 
    ))
  })
}

export const detailAgencies = (id, successCB, failedCB) => async dispatch => {
  await dispatch({ type: 'LOAD_DETAIL_AGENCIES' })
  const params = {
    'id': id
  }
  API.GET('/agency/getById/', params).then((response) => {
    dispatch({ 
      type: 'LOAD_DETAIL_AGENCIES_SUCCESS', 
      payload : { 
        data: response.data 
      } 
    })
    return successCB && successCB(response)
  }).catch((err) => {
    return (
      failedCB && failedCB(err),
      dispatch(errorHandler(
        err, 
        dispatch({ type: 'LOAD_DETAIL_AGENCIES_FAILED' }), 
      ))
    )
  })
}

export const masterAgencies = (successCB, failedCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_MASTER_AGENCIES' })
  return API.GET('/agency_type/getList').then((response) => {
    dispatch({
      type: 'LOAD_DATA_MASTER_AGENCIES_SUCCESS', 
      payload: {
        data: response.data,
        pagination: {
          page: null,
          total: null,
          perpage: null
        }
    }})
    return successCB && successCB(response.data)
  }).catch((err) => {
    failedCB && failedCB()
    return dispatch(errorHandler(
      err, 
      dispatch({ type: 'LOAD_DATA_MASTER_AGENCIES_FAILED' }), 
    ))
  })
}

export const createAgency = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/agency/add', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const editAgency = (value, successCB, failedCB) => () => {
  API.POST_FORM_DATA('/agency/update', value).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const enableAgency = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/agency/enableUser', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}

export const disableAgency = (value, successCB, failedCB) => () => {
  const params = {
    id: value
  }
  API.POST_WITH_PARAMS('/agency/disableUser', params).then((response) => {
    return successCB && successCB(response)
  }).catch((err) => {
    return failedCB && failedCB(err)
  })
}